import { LABELS } from '~/resources/Labels';
import { FormScriptResponse } from '~/models/Commons ';
import { SIMPLDialog } from '../../components/commons/dialog/SimplDialog';
import SIMPLFile from '../../components/commons/input/SIMPLFile';
import { useDropzone } from 'react-dropzone';
import getInputClassFile from '~/assets/styles/classes/InputClasses';
import { SIMPLButtonCustomized } from '../../components/commons/button/SIMPLButtonCustumized';
import { useFormConfigFile } from './UseFormConfigFile';

interface Prop {
  onCloseModal: () => void;
  editedItem: FormScriptResponse | null;
  item: FormScriptResponse;
  setConfig: Function;
  refetch: () => void;
}

const valueClass =
  'py-3 px-2 bg-[#efefef] rounded-md break-words max-w-[600px]';
const labelClass = 'font-semibold max-w-[300px]';
export const ConfigFile = ({
  onCloseModal,
  editedItem,
  setConfig,
  refetch,
  item,
}: Prop) => {
  const { handleSubmit, errors, currentConfigFiles, onConfigDrop, submitForm } =
    useFormConfigFile(
      editedItem,
      onCloseModal,
      refetch,
      item.scriptIdentify.deploymentScriptId
    );

  // Second Dropzone for configFiles (accepts only YAML)
  const {
    getRootProps: getConfigRootProps,
    getInputProps: getConfigInputProps,
    isDragActive: isConfigDragActive,
  } = useDropzone({
    onDrop: onConfigDrop,
    maxFiles: 1,
    accept: {
      'application/x-yaml': ['.yml', '.yaml'],
    },
  });
  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    handleSubmit(submitForm)(event);
    setConfig({
      key: '',
      direction: LABELS.ASC,
    });
  };

  const renderButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Cancel"
          secondary
          buttonHandlerAction={onCloseModal}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized
          label={editedItem ? LABELS.Update : LABELS.Submit}
          primary
        />
      </div>
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={LABELS.ConfigFiles}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
    >
      <div className="w-auto pb-3 flex flex-col">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Title}</div>
            <div className={valueClass}>{item.title}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Provider}</div>
            <div className={valueClass}>{item.cloudProvider.cloudProviderName}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3 pb-2">
          <div className="flex-1 truncate">
            <SIMPLFile
              required
              errors={errors}
              errorFieldName="configFiles"
              currentScript={currentConfigFiles}
              LABELS={LABELS}
              labelName={LABELS.ConfigFiles}
              getRootProps={getConfigRootProps}
              getInputProps={getConfigInputProps}
              getInputClassFile={getInputClassFile}
              isDragActive={isConfigDragActive}
            />
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1 truncate">
            <div className={labelClass}>{LABELS.ConfigFilesList}</div>
            <div style={{ overflowY: 'scroll', maxHeight: '200px' }}>
              {item.configFiles.length > 0 ? (
                <ul>
                  {item.configFiles.map((configFile, index) => (
                    <li
                      key={configFile.fileName || index}
                      className={valueClass}
                    >
                      {configFile.fileName}
                    </li>
                  ))}
                </ul>
              ) : (
                <div className={valueClass}>No config files available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};
